/** Borang penyerahan baharu, laporan semakan dan halaman butiran penyerahan (pelan E). */
export default {
  form: {
    title: 'Penyerahan baharu',
    back: 'Kembali ke senarai penyerahan',
    notAllowed:
      'Anda tidak boleh mencipta penyerahan. Minta pentadbir menambah anda ke kumpulan penyemak atau pelulus.',
    sectionSubmission: 'Penyerahan',
    sectionDrawing: 'Lukisan',
    sectionAttributes: 'Butiran pelan',
    sectionApplicant: 'Pemohon',
    titleLabel: 'Nama projek',
    profileLabel: 'Jenis pelan',
    crsLabel: 'Sistem koordinat',
    choose: 'Pilih…',
    fileLabel: 'Lukisan CAD (.dwg atau .dxf)',
    fileHint: 'Sehingga {{max}} MB. DWG daripada AutoCAD 2000 hingga 2018, atau DXF.',
    fileChosen: '{{name}} ({{size}})',
    applicantName: 'Nama pemohon',
    applicantFirm: 'Firma',
    applicantEmail: 'E-mel',
    applicantRegNo: 'No. pendaftaran profesional',
    submit: 'Hantar untuk semakan',
    retry: 'Cuba lagi',
    cancelUpload: 'Batalkan muat naik',
    draftCreated: 'Draf {{caseRef}} telah dicipta. Butirannya dikunci; Cuba lagi akan menyambung dari muat naik.',
    openSubmission: 'Buka penyerahan',
    pollTimeout: 'Semakan mengambil masa lebih lama daripada dijangka. Buka penyerahan untuk mengikutinya.',
    errors: {
      required: 'Wajib diisi.',
      notANumber: 'Masukkan nombor.',
      notAYear: 'Masukkan tahun empat digit.',
      email: 'Masukkan alamat e-mel yang sah.',
      fileMissing: 'Pilih lukisan untuk dimuat naik.',
      fileType: 'Pilih fail .dwg atau .dxf.',
      fileEmpty: 'Fail kosong.',
      fileTooLarge: 'Fail melebihi {{max}} MB.',
    },
    phase: {
      creating: 'Mencipta penyerahan…',
      uploading: 'Memuat naik lukisan… {{percent}}%',
      finalizing: 'Menyemak muat naik…',
      submitting: 'Menghantar…',
      checking: 'Menukar dan menyemak lukisan…',
    },
  },
  report: {
    title: 'Laporan semakan',
    pending: 'Lukisan masih disemak ({{status}}).',
    errored: 'Semakan tidak dapat dijalankan. Penyemak boleh mencubanya semula.',
    none: 'Belum ada semakan bagi versi ini.',
    zoomTo: 'Zum ke',
    areas: 'Keluasan',
    siteArea: 'Luas tapak',
    declaredArea: 'Luas yang diisytiharkan',
    byClass: 'Mengikut guna tanah',
    classColumn: 'Guna tanah',
    areaColumn: 'Luas',
    plotsColumn: 'Plot',
    unclassified: 'Tidak dikelaskan',
    noFindings: 'Tiada penemuan.',
    revision: 'Versi {{revision}}',
  },
  detail: {
    back: 'Kembali ke senarai penyerahan',
    revision: 'Versi {{revision}}',
    applicant: 'Pemohon',
    attributes: 'Butiran',
    profile: 'Jenis pelan',
    crs: 'Sistem koordinat',
    map: 'Pratonton peta',
    revisions: 'Versi',
    timeline: 'Garis masa',
    actions: 'Tindakan',
    noActions: 'Tiada tindakan tersedia untuk anda pada peringkat ini.',
    viewReport: 'Lihat laporan',
    reportMissing: 'Laporan semakan tidak dapat dimuatkan.',
    replayed: 'Tindakan itu telah pun dilaksanakan.',
    done: 'Selesai.',
    notFound: 'Penyerahan ini tidak wujud atau anda tidak boleh melihatnya.',
    disabledBecause: 'Tidak tersedia: {{reasons}}',
    columns: {
      revision: 'Versi',
      file: 'Fail',
      status: 'Semakan',
      finished: 'Selesai pada',
    },
  },
} as const
